var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCatholms = function SvgCatholms(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 499 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M189.031 135.483c1.857-45.03 8.885-71.605 16.082-97.563 5.677 3.917 16.93 14.493 24.806 22.237.744.73 25.098-.863 34.881 0 3.078.273 23.175-23.254 26.396-21.183 1.616 1.039 14.134 55.786 18.749 113.95",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M267.862 85.29c-.705 3.473-.308 7.189 1.125 10.406 2.855-2.473 2.372-8.003-.861-9.889l-.56 3.638M244.347 103.637c3.267-1.181 5.958-3.614 7.276-6.572M142.671 90.493c3.606-.794 38.249-6.857 65.597-.197M139.392 106.922c14.82-5.988 53.223-10.853 68.877-9.68M145.952 123.352c14.418-7.006 39.881-13.586 59.036-13.121M286.985 88.82c21.247-2.638 55.721-2.011 72.156 1.673M293.545 100.568c13.995-.353 39.75-1.548 62.316 9.64M286.985 106.922c6.922.586 41.397 6.016 59.036 19.716M321.644 221.483c-.054-22.955-6.903-45.125-11.535-67.409M178.277 217.842c1.316-19.739 4.463-39.33 9.039-58.57",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 250,
    y: 0,
    width: 3,
    height: 2
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.707.294h1.949v1.365h-1.949V.294Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.681 1.071c.499 0 .501-.777 0-.777-.498 0-.5.777 0 .777Z",
    fill: "currentColor"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M233.711 60.59c-.174 3.945 1.294 7.56 5.583 9.963 2.427 1.359 5.017 1.663 7.576 1.712 3.432.07 6.924-.316 10.148-2.279 2.995-1.821 5.474-3.932 5.831-9.221a86.844 86.844 0 0 0-29.138-.176Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M223.163 53.66c1.965-6.913 11.238-29.367 22.763-25.31M273.216 53.203c-1.951-6.904-11.251-28.848-22.603-24.853",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.864 18.14c-.216-.653-.464-1.293-.811-1.719-.347-.428-.81-.607-1.191-.289-.592.494-.74 1.898-.709 3.08.041 1.59.298 3.256.955 4.31.55.887 2.387 2.847 2.939 1.215.474-1.396-.787-5.41-1.183-6.598Z",
    fill: "#FFDF2C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M246.864 18.14c-.216-.653-.464-1.293-.811-1.719-.347-.428-.81-.607-1.191-.289-.592.494-.74 1.898-.709 3.08.041 1.59.298 3.256.955 4.31.55.887 2.387 2.847 2.939 1.215.474-1.396-.787-5.41-1.183-6.598Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M248.797 24.44c.243-1.96.615-4.209 1.646-4.935.314-.22.729-.215.922.285.16.416.1.986.004 1.46-.269 1.33-.77 2.502-1.411 3.304-.493.617-1.064 1.018-1.53 1.7",
    fill: "#FFDF2C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M248.797 24.44c.243-1.96.615-4.209 1.646-4.935.314-.22.729-.215.922.285.16.416.1.986.004 1.46-.269 1.33-.77 2.502-1.411 3.304-.493.617-1.064 1.018-1.53 1.7",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M276.935 129.961a57.36 57.36 0 0 1-2.048-5.311c-2.748-8.282-3.243-15.572-1.105-16.285 2.138-.711 6.098 5.426 8.846 13.706a57.688 57.688 0 0 1 1.587 5.729c.06.275.116.547.171.816",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M296.281 177.216c-9.045-10.764-17.439-20.565-18.661-21.795l18.661 21.795Z",
    fill: "#FFDF2C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M296.281 177.216c-9.045-10.764-17.439-20.565-18.661-21.795M277.631 130.077c5.784-10.089 29.869 19.095 39.896 31.339 3.549 4.334 6.001 9.452 7.071 14.954 1.465 7.556.631 18.546-6.983 30.896",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M284.577 137.723c-2.641-5.902-7.595-6.989-9.245-6.447-2.366.779-2.598 3.148-2.764 4.171-.053.328-.103.685.025.96M282.301 141.767c-1.914-2.705-6.008-4.936-9.253-5.044-.602-.021-1.36.225-1.797.672-.437.447-.717 1.035-.91 1.638-.505 1.572.655 4.551 1.768 5.686M279.149 147.511c-1.737-2.047-3.863-3.32-5.557-2.882-1.064.275-1.241 1.364-1.27 1.798-.166 2.37 1.15 4.297 2.467 5.871a51.518 51.518 0 0 0 2.832 3.122",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M284.954 92.298c0 9.438-7.637 17.09-17.058 17.09-9.422 0-17.059-7.652-17.059-17.09 0-9.438 7.637-17.09 17.059-17.09 9.421 0 17.058 7.652 17.058 17.09Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M224.35 92.06c1.676-2.396 4.761-3.714 7.647-3.267M295.153 176.02c5.196 6.228 8.215 14.245 8.423 22.359M105.648 250.394c-2.477-3.804-4.319-17.543-1.261-24.062 2.477 3.803 11.719 12.607 11.719 12.607s-3.255-9.61 1.928-16.415c4.603 3.519 9.53 10.932 9.727 27.06 3.25-6.545 4.663-10.675 8.526-11.194 2.703-.365 4.896 1.31 6.794 5.192-.702-5.225.287-8.117 2.992-8.48 4.055-.547 6.792 5.192 9.528 10.932M239.922 238.425c2.003-5.59 2.039-9.731.323-12.257-2.477-3.804-10.11-.609-11.43 5.676.606-10.13-4.061-15.609-11.461-10.673-2.735-5.738-6.611-3.838-9.591 3.261-2.996-7.673-8.464-2.997-11.43 5.678-4.861-5.453-8.724-4.934-12.236-.324-1.064-7.933-5.665-11.452-11.459-10.673-5.796.781-9.306 5.391-8.242 13.326-4.42-2.163-7.999.484-11.171 7.611M367.638 241.689c2.169-3.88 4.822-9.22 9.552-10.374 5.248-1.283 8.337 3.011 7.737 7.931 6.271-11.371 16.889-.666 22.095 5.68M370.343 235.909c-5.192-6.841-10.482-9.369-16.449-7.257.662-7.65-4.738-12.066-12.941-12.779-8.201-.714-14.282 2.704-14.944 10.354-5.403-4.418-10.869-4.893-17.112.391-5.061-8.335-13.213-12.803-16.608-5.393-4.919-6.818-10.546-8.622-13.783-3.077-10.885-4.706-16.854.601-14.944 10.354-2.507-6.045-13.535-9.071-16.611-5.391-2.14 2.444-1.658 6.433 1.733 11.805M39.48 208.497c-2.17-3.88-4.82-9.22-9.55-10.374-5.25-1.283-8.339 3.011-7.739 7.931-6.271-11.371-16.889-.666-22.095 5.68M36.776 202.717c5.192-6.841 10.481-9.37 16.449-7.257-.663-7.65 4.74-12.066 12.94-12.779 8.201-.714 14.282 2.704 14.945 10.354 5.402-4.418 10.869-4.893 17.111.391 5.061-8.336 13.214-12.803 16.611-5.393 4.917-6.818 10.545-8.622 13.78-3.077 10.885-4.706 16.855.601 14.945 10.354 2.506-6.045 13.537-9.071 16.61-5.391 2.14 2.444 1.659 6.433-1.732 11.805M376.953 207.188c-1.095-4.309-2.284-10.153-6.556-12.492-4.742-2.595-8.833.755-9.519 5.662-3.131-12.607-16.146-5.006-22.81-.221M375.828 200.904c6.779-5.268 12.54-6.343 17.761-2.761 1.329-7.562 7.686-10.432 15.792-9.003 8.107 1.432 13.102 6.305 11.773 13.867 6.358-2.872 11.762-1.917 16.432 4.801 7.037-6.746 16.062-8.956 17.436-.918 6.508-5.316 12.409-5.605 14.109.588 11.726-1.734 16.127 4.938 11.771 13.867 3.978-5.194 15.414-5.268 17.437-.918 1.438 2.917-.055 6.646-4.713 10.957M246.421 26.886a223.087 223.087 0 0 0-5.391 16.245c-.998 3.446-1.92 7.09-1.105 10.584M251.581 27.597c.322 3.69 2.419 6.952 3.616 10.455 1.74 5.094 1.555 10.62 1.35 15.999",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M234.702 38.941c6.81.31 13.625.485 20.441.518 2.264.012 4.626-.014 6.647-1.035M230.55 47.302a82.952 82.952 0 0 1 9.419.502c8.378.924 16.981 3.1 25.08.767M236.934 65.172c4.054.355 8.125-.123 12.192-.263 4.066-.143 8.256.083 11.971 1.745M202.882 199.204a86.94 86.94 0 0 0-2.074 23.26",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M248.358 209.092c-.234-22.69-4.51-45.354-12.596-66.757 5.802-5.21 14.864-6.383 21.465-2.049 2.495 10.224 5.475 21.476 7.969 31.699 2.586 10.6 5.188 21.348 4.761 32.206-6.569 4.079-13.751 4.248-21.599 4.901Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M235.626 169.261a84.37 84.37 0 0 1-3.787 30.174c-.06.189-.113.418.02.566.109.121.29.127.452.127 4.034-.047 8.069-.094 12.103-.139M258.919 142.718a49.32 49.32 0 0 0 8.057-1.505M265.089 163.822c4.36-1.029 8.721-2.058 13.081-3.089.109-.025.222-.033.332-.023M189.207 135.361c-1.917 1.755-2.675 4.415-3.326 6.935-.643 2.501-1.267 5.038-1.279 7.621-.011 2.581.649 5.252 2.317 7.22M245.821 140.031c7.88 21.333 10.563 44.177 13.191 66.771",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M239.376 150.878a180.241 180.241 0 0 1 17.748-3.29M242.105 160.99a37.125 37.125 0 0 1 16.095-3.809M244.04 170.292a118.147 118.147 0 0 1 17.798-3.05M247.394 179.691a49.908 49.908 0 0 1 17.314-1.837M248.049 189.649l17.994-.887c.406-.019.854-.634.446-.648M249.496 199.744c5.924.131 11.851.1 17.774-.094M242.568 181.662a199.928 199.928 0 0 1-3.445 17.332",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M234.611 193.287a15.763 15.763 0 0 0 8.76.818c.246-.047.523-.123.637-.345.115-.225-.132-.571-.343-.438M235.722 185.197c2.433.308 4.925.129 7.287-.527M236.079 176.52l6.096.02c.193 0 .429-.026.503-.203.076-.178-.282-.338-.286-.145M186.468 146.346c12.28 2.464 22.673 4.617 35.063 6.458 4.587.682 9.261 1.32 13.839.586M261.135 152.74l8.948-1.529c.236-.041.499-.098.629-.299.129-.201-.039-.556-.267-.478",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M196.538 140.916c-3.173 5.129-3.941 11.684-2.043 17.41M203.308 142.844c-2.212 5.012-2.246 10.943-.09 15.981M212.298 144.225a52.987 52.987 0 0 0-.337 17.436M221.273 144.559l.423 17.806M229.345 145.364c1.443 1.244 1.969 3.23 2.294 5.108.651 3.763.795 7.615.431 11.416-.07.723.043 1.714.764 1.793M264.543 143.374c2.281 4.047 3.452 8.61 4.596 13.115l1.128 4.432.047.191",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m247.267 59.732.805 11.19M190.619 135.676c14.71 6.646 27.612 7.56 44.665 7.688M189.151 156.81c15.772 5.469 33.092 8.494 50.552 9.052",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.096)",
    d: "M0 0h498.768v250.394H0z"
  })))));
};
export default SvgCatholms;